/**
 * Provides JS functionality for tracking alert display.
 */
export class RelatedContent extends DrupalBehavior {
  onContent(context) {
    const showMore = context.querySelector('.related-content__show-more');
    if (showMore) {
      const showMoreList = context.querySelectorAll(
        '.related-content__show-more'
      );
      showMoreList.forEach((relatedContent) => {
        const component = relatedContent.parentNode;
        var maxHeight = 0;
        const itemsWrapper = component.querySelector(
          '.related-content__content-wrapper'
        );
        const itemLists = component.querySelectorAll(
          '.related-content__content-wrapper ul'
        );
        itemLists.forEach((list) => {
          var listHeight = 0;
          const items = list.querySelectorAll('li');
          items.forEach((item, index) => {
            if (index < 3) {
              listHeight += $(item).outerHeight(true);
            }
          });
          /* istanbul ignore else - this is never false */
          if (listHeight > maxHeight) {
            maxHeight = listHeight;
          }
        });

        var maxTabletHeight = 0;
        const tabletItemsWrapper = component.querySelector(
          '.related-content__content-wrapper--tablet'
        );
        const tabletLists = component.querySelectorAll(
          '.related-content__content-wrapper--tablet ul'
        );
        tabletLists.forEach((list) => {
          var listHeight = 0;
          const items = list.querySelectorAll('li');
          items.forEach((item, index) => {
            if (index < 3) {
              listHeight += $(item).outerHeight(true);
            }
          });
          /* istanbul ignore else - this is never false */
          if (listHeight > maxTabletHeight) {
            maxTabletHeight = listHeight;
          }
        });

        var maxMobileHeight = 0;
        const mobileItemsWrapper = component.querySelector(
          '.related-content__content-wrapper--mobile'
        );
        const mobileListItems = component.querySelectorAll(
          '.related-content__content-wrapper--mobile li'
        );
        mobileListItems.forEach((item, index) => {
          if (index < 9) {
            maxMobileHeight += $(item).outerHeight(true);
          }
        });

        gsap.set(itemsWrapper, { height: maxHeight });
        gsap.set(tabletItemsWrapper, { height: maxTabletHeight });
        gsap.set(mobileItemsWrapper, { height: maxMobileHeight });

        $('.related-content__show-more', component).on('click', function (e) {
          e.preventDefault();
          let $toggleText = $(this).find('.text');
          let $wrapper = $(this).parent();
          $wrapper.toggleClass('open');
          let $items = $wrapper.find('.related-content__content-wrapper');
          let $tabletItems = $wrapper.find(
            '.related-content__content-wrapper--tablet'
          );
          let $mobileItems = $wrapper.find(
            '.related-content__content-wrapper--mobile'
          );
          if ($wrapper.hasClass('open')) {
            $toggleText.text('Show Less');
            gsap.to($items, {
              duration: 0.5,
              ease: 'power4.out',
              height: 'auto',
            });
            gsap.to($tabletItems, {
              duration: 0.5,
              ease: 'power4.out',
              height: 'auto',
            });
            gsap.to($mobileItems, {
              duration: 0.5,
              ease: 'power4.out',
              height: 'auto',
            });
          } else {
            $toggleText.text('Show More');
            gsap.to($items, {
              duration: 0.5,
              ease: 'power4.out',
              height: maxHeight,
            });
            gsap.to($tabletItems, {
              duration: 0.5,
              ease: 'power4.out',
              height: maxTabletHeight,
            });
            gsap.to($mobileItems, {
              duration: 0.5,
              ease: 'power4.out',
              height: maxMobileHeight,
            });
          }
        });
      });
    }
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'related_content',
  RelatedContent
);
